import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'

const InvoicesExporterSidePanel = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const backUrl = navigation.finance.invoices.list.fullPath()

  return (
    <ExportSidepanel
      resource="finance.financial_document"
      onClose={() => navigate(backUrl)}
      overrideFilters={{ operation_type: ['purchase'] }}
    />
  )
}

export default InvoicesExporterSidePanel
